import { useState, MouseEvent } from 'react';
import { Link as RouterLink } from 'react-router-dom';


import { List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';


import { UserOutlined, LogoutOutlined } from '@ant-design/icons';

interface ProfileTabProps {
  handleLogout: (event: MouseEvent<HTMLElement>) => void;
}

const ProfileTab: React.FC<ProfileTabProps> = ({ handleLogout }) => {
  const [selectedIndex, setSelectedIndex] = useState<number>(0);

  const handleListItemClick = (event: MouseEvent<HTMLElement>, index: number) => {
    setSelectedIndex(index);
  };

  return (
    <List component="nav" sx={{ p: 0, '& .MuiListItemIcon-root': { minWidth: 32 } }}>
     
      <ListItemButton
        selected={selectedIndex === 1}
        onClick={(event) => handleListItemClick(event, 1)}
        component={RouterLink}
        to="/profiles/account/basic"
      >
        <ListItemIcon>
          <UserOutlined />
        </ListItemIcon>
        <ListItemText primary="View Profile" />
      </ListItemButton>
 
      <ListItemButton selected={selectedIndex === 2} onClick={handleLogout}>
        <ListItemIcon>
          <LogoutOutlined />
        </ListItemIcon>
        <ListItemText primary="Logout" />
      </ListItemButton>
    </List>
  );
};

export default ProfileTab;
